import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useTypedSelector } from "src/app/store";
import { ArrowDownIcon } from "src/assets/svg";
import { profEduTypes } from "./constants";

function ProfEduTypeFilter({
  setEducationId,
  educationId,
}: {
  setEducationId?: (id: number | undefined) => void;
  educationId?: number;
}) {
  const { t } = useTranslation();
  const { colors } = useTypedSelector((state) => state.layout);
  const { Option } = Select;

  return (
    <Select
      style={{ width: 180 }}
      allowClear
      placeholder={t("header.edu_type")}
      onSelect={(value) => setEducationId && setEducationId(Number(value))}
      defaultValue={
        educationId ? educationId.toString() : `${t("header.edu_type")}`
      }
      onClear={() => setEducationId && setEducationId(undefined)}
      suffixIcon={<ArrowDownIcon color={colors.primary} />}
    >
      {profEduTypes.map((item) => (
        <Option key={item.id + item.name} value={String(item.id)}>
          {t(item.name)}
        </Option>
      ))}
    </Select>
  );
}

export default ProfEduTypeFilter;
